<template>
    <div id="app">
        <form v-on:submit.prevent="saveForm">
            <p>
                Име на секция:
                <input type="text" required v-model="sectionTitle">
            </p>
            <form v-on:submit.prevent="addItem">
                <p>
                    Манипулация:
                    <input type="text" placeholder="" v-model="itemName">
                </p>
                <p>
                    Цена:
                    <input type="number" placeholder="" v-model="itemPrice">
                </p>
                <button type="submit">Добави</button>
            </form>
            <button type="submit">Запази секцията</button>
        </form>
            <div @click="convert">convert</div>
        <div>
            <p>Манипулации:</p>
            <ul>
                <li v-for="item in services" :key="item.key">{{ item.name }}, {{ item.price}}</li>
            </ul>
        </div>
    </div>
</template>
<script>
  import { db } from '../../firebase';
  export default {
    data() {
      return {
        itemName: null,
        itemPrice: null,
        sectionTitle: null,
        services: [],
        prices: null
      }
    },
    created() {
      db.collection('prices').onSnapshot((snapshotChange) => {
        this.prices = snapshotChange.size;
      })
    },
    methods: {
      addItem(){
        let item = {
          name: this.itemName,
          price: this.itemPrice
        };
        this.services.push(item);
        this.itemName = null;
        this.itemPrice = null;
      },

      saveForm() {
        let data = {
          title: this.sectionTitle,
          services: this.services,
          order: this.prices + 1
        };
        console.log(data);
        db.collection('prices').add(data).then(() => {
          alert("Успешно добавена секция!");
          data = {};
        }).catch((error) => {
          console.log(error);
        });
      },
      convert() {
        const arr = [
          ["Магнитотерапия      "," 30 "],
            ["Електростимулация      "," 30 "],
            ["Магнитотерапия + електростимулация  "," 40 "],
            ["Електрофореза            20  Акупунктура + първичен преглед     ","100 "],
            ["Акупунктура       "," 80 "],
            ["Цена за издаване на епикриза       ","100 "],
        ];
        let test = {};
        const res = [];
        arr.forEach(item => {
          test = {
            name: item[0].trim(),
            price: item[1] !== null || item[1] ? item[1].replace(/\s/g,'') : null
          };
          res.push(test);
        });
        console.log(res);
        this.services = res;
      }
    }
  };
</script>
